import {lazy} from 'react';

const Login = lazy(() => import(/* webpackChunkName: "Login" */ './components/login/index'));

export default [
	{
		name: 'login.index',
		path: '/',
		exact: true,
		isPublic: true,
		layout: {
			header: false,
			footer: false,
			sidebar: false,
			minimal: false,
		},
		component: Login,
		routeScopes: ['*'],
	},
	{
		name: 'login',
		path: '/auth/login',
		exact: true,
		isPublic: true,
		layout: {
			header: false,
			footer: false,
			sidebar: false,
			minimal: false,
		},
		component: Login,
		routeScopes: ['*'],
	},
];
